<template>
	<div class="services">
		<div class="site-content">
			<div class="page-header" :style="{backgroundImage:`url(${require('../assets/images/subheader-contact.jpg')})`}" style="background:no-repeat center center;">
			    <div class="container">
			        <div class="breadc-box no-line">
			            <div class="row">
			                <div class="col-md-12">
			                    <h2 class="page-title">联系我们</h2>
			                    <ul id="breadcrumbs" class="breadcrumbs none-style">
			                        <li><router-link :to="{name: 'home'}" class="active_item" exact>首页</router-link></li>
			                        <li class="active">联系我们</li>
			                    </ul>
			                </div>
			            </div>
			        </div>
			    </div>
			</div>
			<section>
				<div class="container">
					<div class="row">
						<div class="col-md-6 col-sm-12">
							<h3>常州市汉邦微云科技有限公司</h3>
							<div class="industris-space-20"></div>
							<div class="contact-info">
								<h4>联系方式 : <span class="text-primary">13915059739</span> </h4>
								<h4>服务QQ : <span class="text-primary">2480611474</span> / <span class="text-primary">120679849</span> / <span class="text-primary">236456549</span></h4>
								<h4>公司地址 : <span class="text-primary">江苏省常州市钟楼区高新技术创业服务中心10楼</span></h4>
							</div>
							<!-- <div class="space-industris"></div> -->
							<hr>
						</div>
						<div class="col-md-6">

								 <div class="baidumap" id="allmap"></div>  
							
						</div>
					</div>
			    </div>
			</section>

			<!-- <section>
				<div class="container">
					<div class="row">
						<div class="col-md-12">
						
							<form class="form-contact" action="" method="post">
								<h3>联系我们</h3>
								<div class="row">
									<div class="col-md-4 form-group">
										<input type="text" name="name" id="name" class="form-control" placeholder="姓名" required>
									</div>
									<div class="col-md-4 form-group">
										<input type="text" name="phone" id="phone" class="form-control" placeholder="联系方式" required>
									</div>
									<div class="col-md-4 form-group">
										<input type="email" name="email" id="email" class="form-control" placeholder="邮箱" required>
									</div>
									<div class="col-md-12 form-group">
										<textarea rows="6" name="message" id="message" class="form-control" placeholder="留言" required></textarea>
									</div>
									<div class="col-md-12">
										<button type="submit" value="提交" class="btn btn-primary">提交</button>
									</div>
								</div>
							</form>

						</div>
					</div>
				</div>
			</section>		 -->
			
		</div>
			
	</div>
</template>

<script> 

	export default {
        name: 'content',  
		components: {},
		data(){
			return{
				
			}
		},
		mounted(){
			this.baiduMap()
		},
		methods:{
			baiduMap() {
				var map = new BMap.Map('allmap') // 创建地图实例

				var point = new BMap.Point(119.892988,31.809729) // 创建点坐标
				map.centerAndZoom(point, 15) // 初始化地图，设置中心点坐标和地图级别
				map.enableScrollWheelZoom(true) //开启鼠标滚轮缩放

				map.addControl(new BMap.NavigationControl())
				map.addControl(new BMap.ScaleControl())
				map.addControl(new BMap.OverviewMapControl())
				map.addControl(new BMap.MapTypeControl())
				//map.setMapStyle({ style: 'midnight' }) //地图风格

				var marker = new window.BMap.Marker(point) // 创建标注
				map.addOverlay(marker) // 将标注添加到地图中

				//提示信息
				var infoWindow = new BMap.InfoWindow('常州市汉邦微云科技有限公司')
				// 鼠标移上标注点要发生的事
				marker.addEventListener('mouseover', function() {
					this.openInfoWindow(infoWindow)
				})

				// 鼠标移开标注点要发生的事
				marker.addEventListener('mouseout', function() {
					//this.closeInfoWindow(infoWindow)
				})
			}		
		}
	}
</script>

<style>
.baidumap {
    width: 100%;
    height: 360px;
    border: 1px solid #1A94E6;
}
</style>



// WEBPACK FOOTER //
// src/pages/content.vue